/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

const WebinarLayoutContainer = styled.div`
  background-image: ${props => `url(${props.backgroundImage})`};
  background-size: auto 530px;
  background-repeat: no-repeat;
  background-position: right top;
  padding-top: 100px;

  .webinar-layout-container--wrapper {
    margin: 0 auto;
    max-width: 1252px;
    padding: 0 28px;
    position: relative;
  }

  @media (max-width: 768px) {
    background-size: auto;

    .webinar-layout-container--wrapper {
      padding: 0 20px;
    }
  }
`;

export { WebinarLayoutContainer };
